/* Fixed campaign window; the separate Halloween clock resets daily. */
(() => {
  function refreshOffers() {
    document.querySelectorAll('[data-ship-sale-end]').forEach((section) => {
      const end = Date.parse(section.dataset.shipSaleEnd);
      if (!Number.isFinite(end) || Date.now() < end) return;
      section.querySelectorAll('[data-ship-offer-copy]').forEach((node) => { node.textContent = 'This sale has ended.'; });
      section.querySelectorAll('[data-ship-sale-link]').forEach((link) => { link.textContent = 'Browse Toy Weapons'; link.href = '/collections/toy-weapons'; });
      document.querySelectorAll('[id$="rich_text_ship_is_sailing_club_2026"]').forEach((node) => { node.hidden = true; });
    });
  }
  refreshOffers();
  window.setInterval(refreshOffers, 60000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshOffers(); });
  document.addEventListener('shopify:section:load', refreshOffers);
})();
